import React from 'react';

import { WarningOutlined } from '@ant-design/icons';
import { Flex, Modal } from 'antd';

export const ConfirmCancelReturnToSenderModal = ({
  confirmRTSModalOpen,
  setConfirmRTSModalOpen,
  handleClickUpdateStatusRTS,
}: {
  confirmRTSModalOpen: boolean;
  setConfirmRTSModalOpen: (open: boolean) => void;
  handleClickUpdateStatusRTS: () => void;
}) => (
  <Modal
    title={
      <Flex gap="small">
        <WarningOutlined style={{ color: '#C82F21' }} />
        Cancel Return to Sender?
      </Flex>
    }
    centered
    open={confirmRTSModalOpen}
    onOk={() => {
      handleClickUpdateStatusRTS();
      setConfirmRTSModalOpen(false);
    }}
    onCancel={() => setConfirmRTSModalOpen(false)}
    okText="Cancel Return to sender"
    cancelText="Keep as RTS"
  >
    <p>
      This will reverse the return process and restore the shipment to its
      previous status.
    </p>
    <br />
    <p>Are you sure you want to proceed?</p>
  </Modal>
);
